const parse = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};

const addMonths = (a, n) => {
  const y = a.getUTCFullYear();
  const m = a.getUTCMonth() + n;
  const last = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
  return new Date(Date.UTC(y, m, Math.min(a.getUTCDate(), last)));
};

export const monthsBetween = (a, d) => {
  let m = (d.getUTCFullYear() - a.getUTCFullYear()) * 12 + d.getUTCMonth() - a.getUTCMonth();
  while (m > 0 && addMonths(a, m) > d) m -= 1;
  return Math.max(m, 0);
};

export const minDeparture = (arrival, minMonths = 1) => {
  if (!arrival) return "";
  return addMonths(parse(arrival), Math.max(1, minMonths)).toISOString().slice(0, 10);
};

const nightPrice = (l, tier) => {
  for (const t of [tier, tier === "1m" ? "3m" : "1m"]) {
    const n = l[`price_${t}_night`];
    const m = l[`price_${t}_month`];
    if (n != null) return Number(n);
    if (m != null) return Number(m) / 30;
  }
  return l.monthly_price != null ? Number(l.monthly_price) / 30 : null;
};

export const stayInfo = (arrival, departure) => {
  if (!arrival || !departure) return null;
  const a = parse(arrival);
  const d = parse(departure);
  const months = monthsBetween(a, d);
  if (months < 1) return null;
  return { months, nights: Math.round((d - a) / 86400000), tier: months >= 3 ? "3m" : "1m" };
};

export const stayEstimate = (l, stay) => {
  const n = stay ? nightPrice(l, stay.tier) : null;
  return n == null ? null : { night: n, total: Math.round(n * stay.nights) };
};

export const eur = (x) => `${Math.round(x).toLocaleString("fr-FR")} €`;
export const frDate = (iso) => (iso ? iso.split("-").reverse().join("/") : "");
